export const isJSON = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const isJsonArray = (str) => {
  try {
    const res = JSON.parse(str);
    return Array.isArray(res);
  } catch (e) {
    return false;
  }
};
